// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".caption[data-v-0356ccb9]{text-transform:uppercase}.body-1[data-v-0356ccb9]{font-weight:500}", ""]);
// Exports
module.exports = exports;
